import LightHouse from './views/light-house.c';

export default LightHouse;
